/**
 * @param {HTMLElement | null | undefined} element
 */
export function isScrolledToBottom(element) {
  if (!element) {
    return true;
  }
  const rect = element.getBoundingClientRect();
  const isVisible = rect.bottom <= window.innerHeight;
  const isScrolled = rect.height + element.scrollTop === element.scrollHeight;
  return isVisible && isScrolled;
}
